import { IonFab, IonFabButton, IonIcon } from '@ionic/react'
import { add } from 'ionicons/icons'
import { useDispatch } from 'react-redux'
import { COUNTRY } from '../const/constants'
import { useAppContext } from '../context/AppContext'
import { useStepsContext } from '../context/StepsContext'
import { COMPLETE_INPUT, newProcedureDate } from '../redux/actions'

interface Props {
  id: string
  href: string
  blockNavigation?: boolean
  procedure?: 'activationPP' | 'portabilidad' | 'nominativity'
}

const AddButton = ({ id, href, blockNavigation, procedure }: Props) => {
  const dispatch = useDispatch()
  const { setBlockNavigation, user, settings }: any = useAppContext()
  const { setInProcess }: any = useStepsContext()
  const automaticPosNumber = () => {
    const storeForm = procedure === 'activationPP' ? 'chipValidationForm' : 'lineValidationPYForm'
    if (user.posActivator) {
      dispatch({
        type: COMPLETE_INPUT,
        payload: {
          name: 'posNumberProcedure',
          value: user.posActivator,
          storeForm
        }
      })
    } else {
      dispatch({
        type: COMPLETE_INPUT,
        payload: { name: 'posNumberProcedure', value: '', storeForm }
      })
    }
  }

  const navigationHandler = () => {
    settings.country === COUNTRY.PY && automaticPosNumber()
    dispatch(newProcedureDate())
    blockNavigation && setBlockNavigation(true)
    setInProcess(true)
  }
  return (
    <IonFab vertical="bottom" horizontal="end" slot="fixed">
      <IonFabButton id={id} routerDirection="none" routerLink={href} onClick={navigationHandler}>
        <IonIcon icon={add} />
      </IonFabButton>
    </IonFab>
  )
}

export default AddButton
